module.exports = __webpack_public_path__ + "img/intro1.73462017.jpg";